import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from '../../Services/theme.service';

@Component({
  selector: 'av-footer',
  imports: [TranslateModule],
  templateUrl: './av-footer.component.html',
  styleUrls: ['./av-footer.component.scss'],
})
export class AvFooterComponent {
  private readonly themeService = inject(ThemeService);

  public readonly logoSrc = computed(() =>
    this.themeService.mode() === 'dark'
      ? 'assets/icons/avyna/logo-white.svg'
      : 'assets/icons/avyna/logo-black.svg',
  );
}
